import ReorderDropzone from './reorder-dropzone.element';

export default ReorderDropzone;

ReorderDropzone.define('wje-reorder-dropzone', ReorderDropzone);
